export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  categoryId: string;
  categoryName: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: number;
  viewCount: number;
  commentCount: number;
  featured: boolean;
  hot: boolean;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'article-1',
    slug: 'top-star-tax-evasion-billions',
    title: '顶流男星被曝偷税漏税超2亿，工作室连夜注销跑路',
    excerpt: '据知情人士透露，某当红顶流男星近日因涉嫌巨额偷税漏税被税务部门约谈，其名下多家公司已紧急注销。该艺人近三年商业代言收入超过8亿元，但申报纳税严重不符。',
    content: `<p>近日，娱乐圈再次掀起税务风暴。据多方消息源证实，一位在影视、综艺、商业代言等多个领域均有极高影响力的顶流男星，因涉嫌偷逃巨额税款被税务部门正式立案调查。</p>
<p>据一位不愿透露姓名的业内人士向本平台爆料，该男星近三年的商业活动收入保守估计超过8亿元人民币，但其个人及关联公司申报的纳税金额与实际收入严重不匹配，累计偷逃税款可能高达2亿元以上。</p>
<p><strong>多家公司紧急注销</strong></p>
<p>记者通过企业信息查询平台发现，与该艺人关联的7家公司中，已有4家在最近一个月内完成了注销程序，另外3家的法人代表也已悄然变更为其亲属。这一系列操作被业内人士解读为"金蝉脱壳"之举。</p>
<p><strong>商业版图受重创</strong></p>
<p>受此消息影响，该艺人代言的12个品牌中已有8个紧急下架了相关广告物料。某国际奢侈品牌中国区负责人向记者透露："我们已经启动了紧急预案，如果消息属实，将在48小时内宣布解约。"</p>
<p>据估算，仅品牌解约一项，该艺人可能面临超过5亿元的违约金索赔。而其主演的三部待播剧也面临播出危机，投资方正在紧急商讨换脸或重拍方案。</p>
<p><strong>圈内人爆料：早有征兆</strong></p>
<p>一位与该艺人有过密切合作的制片人透露："他平时的消费就非常夸张，私人飞机、游艇、豪宅，生活方式完全不像是正常纳税的艺人。圈内其实很多人都知道他有问题，只是没想到金额这么大。"</p>
<p>目前，税务部门尚未对此事做出官方回应。本平台将持续关注事件进展。</p>`,
    categoryId: 'cat-6',
    categoryName: '法律纠纷',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20scene%20showing%20a%20shadowy%20figure%20in%20a%20luxurious%20office%20with%20dim%20lighting%20and%20moody%20atmosphere%2C%20documents%20scattered%20on%20desk%2C%20film%20noir%20style%2C%20warm%20dark%20tones%2C%20mysterious%20and%20tense%20mood&width=800&height=500&seq=article-cover-01&orientation=landscape',
    author: '爆料君',
    publishDate: '2026-08-06',
    readTime: 8,
    viewCount: 1283000,
    commentCount: 5621,
    featured: true,
    hot: true,
    tags: ['偷税漏税', '顶流男星', '税务风暴', '品牌解约'],
  },
  {
    id: 'article-2',
    slug: 'actress-cheating-scandal-evidence',
    title: '当红花旦出轨实锤！深夜与神秘男子酒店共度8小时',
    excerpt: '某85后一线女星被拍到与一名非丈夫男子深夜进入五星级酒店，直到次日清晨方才离开。视频画面清晰可见二人举止亲密，该女星此前一直以"模范妻子"人设活跃于公众视野。',
    content: `<p>娱乐圈又一对"模范夫妻"的人设崩塌了。本平台独家获得了一段监控视频，画面清晰地记录了某85后一线女演员与一名神秘男子深夜进出酒店的完整过程。</p>
<p><strong>时间线还原</strong></p>
<p>根据视频显示的时间戳，当晚22:47，该女星独自驾车抵达某五星级酒店地下车库。约15分钟后，一名身高约185厘米的男子从同一入口进入，二人在地下车库电梯口会合。画面中可以清晰看到，两人见面后立即拥抱，随后牵手进入电梯。</p>
<p>直到次日清晨6:52，二人才一同从电梯走出，男子驾车先行离开，女星随后独自驱车离去。整个"密会"过程长达8小时。</p>
<p><strong>模范人设崩塌</strong></p>
<p>令人震惊的是，该女星与现任丈夫结婚已有7年，育有一子一女，此前一直以恩爱夫妻形象示人。就在上个月，她还在个人社交平台晒出一家四口的温馨合照，配文"这辈子最幸运的事就是遇见你"。</p>
<p>其丈夫是圈外人士，据称是一名成功的投资人。两人结婚以来从未传出过任何负面新闻，是圈内公认的模范夫妻。</p>
<p><strong>神秘男子身份曝光</strong></p>
<p>经多方核实，视频中的神秘男子疑似某知名导演的助理，今年32岁，与该女星因合作一部电视剧而相识。有剧组工作人员透露，两人在拍摄期间就互动频繁，"当时大家都觉得只是工作关系好，没想到会发展成这样。"</p>
<p>截至目前，该女星及其工作室尚未对此事做出回应。其丈夫的社交账号也已设置为私密状态。</p>`,
    categoryId: 'cat-2',
    categoryName: '恋情曝光',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20blurry%20night%20scene%20outside%20a%20luxury%20hotel%20entrance%20with%20warm%20golden%20lights%2C%20two%20silhouettes%20walking%20close%20together%2C%20paparazzi%20photography%20style%2C%20noir%20cinematic%20aesthetic%2C%20mysterious%20and%20romantic%20yet%20scandalous%20mood&width=800&height=500&seq=article-cover-02&orientation=landscape',
    author: '深夜狗仔',
    publishDate: '2026-08-06',
    readTime: 7,
    viewCount: 2150000,
    commentCount: 8923,
    featured: true,
    hot: true,
    tags: ['出轨', '当红花旦', '酒店密会', '人设崩塌'],
  },
  {
    id: 'article-3',
    slug: 'variety-show-fixed-winner',
    title: '某选秀综艺被曝全程剧本操作，冠军早已内定',
    excerpt: '一位参与过两季选秀节目的幕后工作人员实名爆料，称某热门选秀综艺从海选到决赛全程按剧本操作，所谓的"观众投票"纯属虚构，冠军人选在节目开播前就已确定。',
    content: `<p>选秀综艺的"公平公正"外衣终于被撕开了。一位曾在某头部视频平台选秀节目担任制片助理的业内人士，近日通过本平台实名爆料，揭露了选秀综艺背后令人震惊的内幕。</p>
<p><strong>"冠军早定了"</strong></p>
<p>"说实话，节目还没开始录第一期，冠军就已经定好了。"这位化名"小K"的知情人士表示，"播出期间的所谓观众投票、现场评审打分，全部都是做给外人看的。最终的结果在签约阶段就已经写进了合同里。"</p>
<p>据小K透露，选秀节目的选手分为三个等级：S级（内定冠军候选人）、A级（已签约公司的重点培养对象）、B级（纯粹陪跑的素人选手）。"S级选手的经纪公司早在节目筹备阶段就已经和平台方达成了合作协议，包括后续的影视资源、商业代言、综艺通告全都打包谈好了。"</p>
<p><strong>投票造假手法曝光</strong></p>
<p>关于观众最为关注的投票环节，小K的解释让人大跌眼镜："后台有一个'票数调节系统'，可以随时调整任何选手的实时票数。导演组会定期开会讨论'剧情走向'，哪个选手该淘汰了、哪个选手该逆袭了，全都是事先设计好的。"</p>
<p>"有时候一个选手明明上一期还排名垫底，下一期突然冲到第一，弹幕都在刷'逆袭'，其实就是导演觉得这个'剧本'比较好看。"</p>
<p><strong>剪辑黑幕</strong></p>
<p>除了投票造假，后期的恶意剪辑也是家常便饭。"有的选手只是说了句'今天有点累'，经过剪辑之后就变成了'我不想比了'。还有一次，把一个选手打哈欠的镜头剪到导师点评的片段里，让观众觉得这个选手不尊重导师。"</p>
<p>该爆料在社交平台引发巨大反响，相关话题迅速登上热搜。涉事平台目前尚未对此做出回应。</p>`,
    categoryId: 'cat-3',
    categoryName: '综艺内幕',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20stage%20with%20bright%20spotlights%20and%20confetti%2C%20a%20single%20performer%20in%20silhouette%20center%20stage%2C%20behind%20the%20scenes%20vibe%2C%20dark%20moody%20edges%20with%20vibrant%20center%2C%20contrast%20between%20glamour%20and%20darkness&width=800&height=500&seq=article-cover-03&orientation=landscape',
    author: '圈内揭秘',
    publishDate: '2026-08-05',
    readTime: 6,
    viewCount: 967000,
    commentCount: 4321,
    featured: true,
    hot: true,
    tags: ['选秀综艺', '剧本造假', '投票黑幕', '实名爆料'],
  },
  {
    id: 'article-4',
    slug: 'actors-on-set-fight',
    title: '两大影帝片场互殴！新片拍摄被迫停工',
    excerpt: '某大制作电影拍摄现场发生严重冲突，两位主演因剧本分歧在片场大打出手，导致多人受伤，制片方紧急叫停拍摄。据悉两人积怨已久，此次冲突只是导火索。',
    content: `<p>电影圈的"兄弟情深"背后，原来暗藏着如此激烈的矛盾。本平台独家获悉，某投资超过5亿的大制作电影的拍摄现场，日前发生了一起震惊全组的斗殴事件。</p>
<p><strong>冲突起因</strong></p>
<p>据现场工作人员描述，当天的冲突源于一场对手戏的拍摄。两位主演——均获得过影帝头衔的实力派演员——就某句台词的表达方式产生了严重分歧。起初只是言语争执，但很快升级为肢体冲突。</p>
<p>"两人突然就扭打在一起了，现场的桌椅都被撞翻了，茶水洒了一地。"一位目击者回忆道，"其中一个被推倒后撞到了摄影机的摇臂，额头磕出了血。工作人员赶紧上去拉架，结果好几个人都被波及了。"</p>
<p><strong>积怨已深</strong></p>
<p>据了解，两位影帝的矛盾并非一日之寒。早在五年前，两人曾因一部电影的番位问题（谁的名字排在前面）产生过激烈的矛盾。当时虽然表面上握手言和，但私底下一直心存芥蒂。</p>
<p>这次合作是新片的投资方极力促成的，目的是借助两位影帝的号召力打造一部票房爆款。然而事与愿违，两位主演在片场的冷战状态早已让剧组氛围压抑不堪。</p>
<p><strong>制片方损失惨重</strong></p>
<p>目前拍摄已全面暂停，制片方正在紧急协调中。据估算，每停工一天的直接损失超过200万元。更棘手的是，两位主演的档期都非常紧张，如果延期太久，后续的协调将极为困难。</p>
<p>有知情人士透露，投资方正在考虑换角的可能性，但在目前的市场环境下，找到合适且档期匹配的替代人选几乎是不可能的任务。</p>`,
    categoryId: 'cat-4',
    categoryName: '影视幕后',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20chaotic%20movie%20set%20with%20overturned%20equipment%20and%20scattered%20props%2C%20dramatic%20lighting%20with%20harsh%20shadows%2C%20two%20figures%20in%20confrontation%2C%20behind%20the%20scenes%20movie%20production%20aesthetic%2C%20tense%20cinematic%20mood&width=800&height=500&seq=article-cover-04&orientation=landscape',
    author: '片场密探',
    publishDate: '2026-08-04',
    readTime: 7,
    viewCount: 756000,
    commentCount: 3210,
    featured: false,
    hot: true,
    tags: ['影帝互殴', '片场冲突', '番位之争', '拍摄停工'],
  },
  {
    id: 'article-5',
    slug: 'awards-show-fashion-disaster',
    title: '年度颁奖礼红毯翻车现场：一线女星穿山寨高定被品牌方公开打脸',
    excerpt: '某一线女星在年度颁奖典礼上身穿的"高级定制礼服"被网友扒出是山寨货，品牌官方火速发布声明否认与该艺人有任何合作关系，该女星造型团队被指专业度堪忧。',
    content: `<p>红毯向来是明星争奇斗艳的战场，但有时也会变成翻车现场。上周举办的年度娱乐颁奖典礼上，一位一线女星的造型就引发了一场"山寨风波"。</p>
<p><strong>"高定"变"山寨"</strong></p>
<p>当晚，这位女星身穿一袭红色鱼尾礼服亮相红毯，工作室随即发布通稿称"身着某国际顶级奢侈品牌2026秋冬高级定制系列"。然而，眼尖的时尚博主很快发现，这条裙子与该品牌秀场款存在多处细节差异。</p>
<p>更尴尬的是，该奢侈品牌中国区官方账号在当晚11点突然发布了一条声明："品牌目前在中国的官方合作伙伴名单中不包含艺人XXX，请广大消费者通过官方渠道了解品牌最新动态。"虽然没有直接点名"山寨"，但发布时机之微妙令人浮想联翩。</p>
<p><strong>造型团队甩锅</strong></p>
<p>事件发酵后，该艺人的造型师在朋友圈发文称："礼服确实是从国外渠道借到的，我们也是受害者。"但这一说法很快被业内人士打脸——某时尚买手透露，真正的品牌高定礼服都有严格的借衣流程，不可能通过"渠道"操作。</p>
<p>"说白了就是借不到真货，又想在红毯上出风头，所以找人仿了一条。这在圈内不是第一次了，但是被品牌方公开打脸的情况还是比较少见的。"</p>
<p><strong>连锁反应</strong></p>
<p>此次事件对该艺人的时尚资源造成了严重打击。据悉，已有两个即将签约的品牌代言合作被紧急叫停，另外三个正在洽谈中的品牌也暂时搁置了合作计划。</p>
<p>一位奢侈品牌公关表示："对于品牌来说，艺人穿山寨比不穿还要糟糕。这说明这个艺人的团队不专业，甚至有法律风险。我们选择合作艺人时，团队的靠谱程度是非常重要的考量因素。"</p>`,
    categoryId: 'cat-5',
    categoryName: '时尚翻车',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20glamorous%20red%20carpet%20event%20with%20bright%20flashbulbs%2C%20a%20woman%20in%20an%20elegant%20red%20evening%20gown%20posing%2C%20luxury%20fashion%20photography%20aesthetic%2C%20dramatic%20lighting%2C%20red%20carpet%20glamour%20with%20a%20hint%20of%20controversy&width=800&height=500&seq=article-cover-05&orientation=landscape',
    author: '时尚纪检委',
    publishDate: '2026-08-03',
    readTime: 5,
    viewCount: 632000,
    commentCount: 2890,
    featured: false,
    hot: false,
    tags: ['红毯翻车', '山寨高定', '品牌打脸', '时尚事故'],
  },
  {
    id: 'article-6',
    slug: 'boy-band-member-secret-marriage',
    title: '当红男团成员隐婚三年，妻子竟是圈外素人',
    excerpt: '某当红男子组合人气成员被曝已在三年前秘密结婚，妻子为一名普通的公司职员，两人育有一子。消息曝光后粉丝群体出现严重分化，部分极端粉丝发起脱粉行动。',
    content: `<p>偶像的"单身人设"再次遭遇现实的重击。本平台独家获悉，某目前国内最炙手可热的男子偶像组合中，一位人气排名前三的成员已在三年前秘密结婚，并且已为人父。</p><p>更多详细内容持续更新中...</p>`,
    categoryId: 'cat-2',
    categoryName: '恋情曝光',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20romantic%20scene%2C%20a%20young%20man%20in%20casual%20clothing%20walking%20hand%20in%20hand%20with%20someone%20in%20a%20quiet%20suburban%20street%20at%20sunset%2C%20warm%20golden%20light%2C%20secretive%20and%20intimate%20mood&width=800&height=500&seq=article-cover-06&orientation=landscape',
    author: '深扒君',
    publishDate: '2026-08-03',
    readTime: 5,
    viewCount: 1890000,
    commentCount: 12045,
    featured: true,
    hot: true,
    tags: ['隐婚', '男团', '粉丝脱粉', '偶像失格'],
  },
  {
    id: 'article-7',
    slug: 'director-abuse-on-set',
    title: '知名导演被控片场虐待群演，多名临时演员联名举报',
    excerpt: '一位曾获国际奖项的知名导演被多名群演联名举报，指控其在拍摄期间存在言语侮辱、超时工作、克扣工资等恶劣行为。目前已有多位演员站出来讲述自己的遭遇。',
    content: `<p>光鲜亮丽的电影工业背后，底层演员的生存状态令人心酸。近日，一位曾获得国际电影节奖项的知名导演，被超过20名群演和临时演员联名举报，指控其在片场存在多项严重不当行为。</p><p>本平台将持续跟进报道。</p>`,
    categoryId: 'cat-4',
    categoryName: '影视幕后',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20a%20director%20chair%20and%20megaphone%20in%20the%20foreground%2C%20silhouettes%20of%20crew%20members%20in%20the%20background%2C%20dark%20and%20tense%20atmosphere%2C%20cinematic%20lighting%20with%20harsh%20contrasts&width=800&height=500&seq=article-cover-07&orientation=landscape',
    author: '行业观察',
    publishDate: '2026-08-02',
    readTime: 6,
    viewCount: 445000,
    commentCount: 2100,
    featured: false,
    hot: false,
    tags: ['导演', '群演', '片场虐待', '联名举报'],
  },
  {
    id: 'article-8',
    slug: 'celebrities-involved-in-illegal-gambling',
    title: '某综艺常驻嘉宾被曝长期参与境外赌博，欠下巨额赌债',
    excerpt: '一位在多个热门综艺中担任常驻嘉宾的艺人，被曝在境外赌场长期参与赌博活动，累计输掉数千万元，目前已被多名债主追债至国内。',
    content: `<p>综艺节目上风趣幽默的他，私底下却深陷赌海。据多位知情人士向本平台证实，一位在多个热门综艺节目中担任常驻嘉宾的知名艺人，近年来频繁出入境外赌场，已欠下巨额赌债。</p><p>更多详情请持续关注本平台后续报道。</p>`,
    categoryId: 'cat-1',
    categoryName: '明星黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20luxurious%20casino%20scene%20with%20playing%20cards%20and%20chips%20on%20green%20felt%2C%20dim%20atmospheric%20lighting%2C%20empty%20chairs%2C%20mysterious%20and%20dangerous%20vibe%2C%20film%20noir%20aesthetic&width=800&height=500&seq=article-cover-08&orientation=landscape',
    author: '赌场线人',
    publishDate: '2026-08-02',
    readTime: 5,
    viewCount: 875000,
    commentCount: 3780,
    featured: false,
    hot: true,
    tags: ['赌博', '综艺嘉宾', '境外赌场', '巨额赌债'],
  },
  {
    id: 'article-9',
    slug: 'surrogate-mother-scandal-exposed',
    title: '三线女星代孕风波：为保身材找代孕，聊天记录全曝光',
    excerpt: '一位以"辣妈"人设活跃的三线女星被曝光通过海外代孕方式生育孩子，其与代孕中介的聊天记录被全部公开，内容触目惊心。',
    content: `<p>"辣妈"的背后竟然另有隐情。近日，一位以"产后身材恢复神速"闻名的三线女星陷入代孕风波，其与海外代孕机构的完整聊天记录被曝光。</p><p>事件仍在持续发酵中，本平台将带来更多独家报道。</p>`,
    categoryId: 'cat-1',
    categoryName: '明星黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20woman%20silhouette%20standing%20by%20a%20window%20with%20curtains%2C%20holding%20a%20phone%20with%20glowing%20screen%2C%20dark%20moody%20lighting%2C%20secretive%20and%20tense%20atmosphere%2C%20cinematic%20noir%20style&width=800&height=500&seq=article-cover-09&orientation=landscape',
    author: '正义狗仔',
    publishDate: '2026-08-01',
    readTime: 6,
    viewCount: 1120000,
    commentCount: 5678,
    featured: false,
    hot: true,
    tags: ['代孕', '三线女星', '聊天记录', '人设造假'],
  },
  {
    id: 'article-10',
    slug: 'streaming-platform-bribery-scandal',
    title: '某平台高管收受回扣内定推荐位，涉及金额超千万',
    excerpt: '某头部视频流媒体平台内容运营部门爆出严重腐败案，多名高管涉嫌收受影视公司回扣，操控平台推荐位分配，涉案金额超过千万元。',
    content: `<p>视频平台的"算法推荐"背后，原来藏着如此深的利益链。本平台独家获悉，某头部视频流媒体平台的内容运营部门近日爆发严重腐败丑闻。</p><p>持续追踪报道中。</p>`,
    categoryId: 'cat-3',
    categoryName: '综艺内幕',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20corporate%20office%20with%20stacked%20documents%20and%20cash%20envelopes%20on%20a%20desk%2C%20dim%20lighting%20with%20a%20single%20desk%20lamp%2C%20corruption%20and%20scandal%20theme%2C%20dark%20cinematic%20aesthetic&width=800&height=500&seq=article-cover-10&orientation=landscape',
    author: '行业深喉',
    publishDate: '2026-08-01',
    readTime: 5,
    viewCount: 534000,
    commentCount: 2456,
    featured: false,
    hot: false,
    tags: ['平台腐败', '高管受贿', '推荐位操控', '影视公司'],
  },
];

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getArticlesByCategory(categoryId: string): Article[] {
  return articles.filter((a) => a.categoryId === categoryId);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.featured);
}

export function getHotArticles(): Article[] {
  return articles.filter((a) => a.hot);
}

export function getLatestArticles(limit: number = 10): Article[] {
  return [...articles].sort((a, b) => 
    new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  ).slice(0, limit);
}

export function getRelatedArticles(article: Article, limit: number = 4): Article[] {
  return articles
    .filter((a) => a.id !== article.id && a.categoryId === article.categoryId)
    .slice(0, limit);
}